import { FC } from 'react';
import { IonToggle } from '@ionic/react';
import { IonToggleCustomEvent, ToggleChangeEventDetail } from '@ionic/core';

export type ICaregiverToggle = {
    checked?: boolean;
    onToggle: (checked: boolean) => void;
};

export const CaregiverToggle: FC<ICaregiverToggle> = ({ checked, onToggle }) => {
    const toggled = (e: IonToggleCustomEvent<ToggleChangeEventDetail<any>>) => {
        onToggle(e.detail.checked);
    };

    return (
        <IonToggle
            data-type="caregiver-toggle"
            checked={checked}
            onIonChange={toggled}
        >
            Primary Caregiver
        </IonToggle>
    );
};
